import { create } from 'zustand';
import { RowData } from '../../components/order/order_table_component';

interface OrderFormState {
    orderRows: RowData[] | [];
    isDialogOpen: boolean;
    isOrderRowEdited: boolean;
    setOrderRows: (orderRows: RowData[]) => void;
    setIsDialogOpen: (isDialogOpen: boolean) => void;
    setIsOrderRowEdited: (isOrderRowEdited: boolean) => void;
}

export const useOrderDialogFormState = create<OrderFormState>((set) => ({
    orderRows: [],
    isDialogOpen: false,
    isOrderRowEdited: false,
    setOrderRows: (orderRows: RowData[]) => set({ orderRows }),
    setIsDialogOpen: (isDialogOpen: boolean) => {
        set({ orderRows: [] });
        set({ isOrderRowEdited: false });
        set({ isDialogOpen });
    },
    setIsOrderRowEdited: (isOrderRowEdited: boolean) => set({ isOrderRowEdited }),
}));

// setOrderRows: (orderRows: RowData[]) => {
//     set({ orderRows: [] });
//     set({ orderRows });
// },
// setIsDialogOpen: (isDialogOpen: boolean) => {
//     set({ isDialogOpen });
// },